module.exports = __webpack_public_path__ + "static/img/typeThree.2fc1035e.png";